<script setup lang="ts">
/** Aventross AGM (Audited) — 원본 합본 문서 5부((Incorporated In Singapore)). gen_vue 로 템플릿 글자 그대로 생성. */
import CddVarField from '../../../aura/agm/cdd/CddVarField.vue';
import DocScope from '../../../aura/agm/cdd/DocScope.vue';
import AgmSigners from '../../../aura/agm/cdd/AgmSigners.vue';
import { useRepeat } from '../useRepeat';
import '../../../aura/agm/docs/agmDoc.css';
import '../avDoc.css';

const R = useRepeat();
void CddVarField; void DocScope; void AgmSigners;
</script>

<template>
  <div class="agm-doc av-doc">
    <p class="doc-p center bold"><CddVarField field-key="company_name" label="Company Name" /></p>
    <p class="doc-p center">(Incorporated In Singapore)</p>
    <p class="doc-p center">Company Registration No. <CddVarField field-key="company_registration_no" label="Company Registration No." /></p>
    <div class="gap" />
    <p class="doc-p center">ATTENDANCE AT ANNUAL GENERAL MEETING</p>
    <div class="gap" />
    <p class="doc-p">Date: <CddVarField field-key="agm_date" label="AGM date" /></p>
    <p class="doc-p">Time: 10:00 am</p>
    <p class="doc-p">Venue: <CddVarField field-key="agm_venue" label="AGM venue" /></p>
    <p class="doc-p">__________________________________________________________________________________</p>
    <div class="gap" />
    <p class="doc-p center">PRESENT</p>
    <div class="gap" />
    <template v-for="id_dir in R.ids('dir')" :key="'dir' + id_dir">
      <DocScope :scope="'dir_' + id_dir + '/'">
        <div class="rep-item"><div class="rep-bar"><span>Director #{{ id_dir }}</span><button type="button" class="rep-rm" title="Remove" @click="R.remove('dir', id_dir)">×</button></div>
          <p class="doc-p center">________________________</p>
          <p class="doc-p center"><CddVarField field-key="director_name" label="Director" /></p>
          <div class="gap" />
        </div>
      </DocScope>
    </template>
    <button type="button" class="rep-add" @click="R.add('dir')">+ Add director</button>
    <template v-for="id_mem in R.ids('mem')" :key="'mem' + id_mem">
      <DocScope :scope="'mem_' + id_mem + '/'">
        <div class="rep-item"><div class="rep-bar"><span>Member #{{ id_mem }}</span><button type="button" class="rep-rm" title="Remove" @click="R.remove('mem', id_mem)">×</button></div>
          <p class="doc-p center">________________________</p>
          <p class="doc-p center"><CddVarField field-key="member_name" label="Member" /></p>
          <div class="gap" />
        </div>
      </DocScope>
    </template>
    <button type="button" class="rep-add" @click="R.add('mem')">+ Add member</button>
    <div class="gap" />
  </div>
</template>
